import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlantasService {
  public url: string;
  
  constructor(
    public _http: HttpClient
  ) {
    this.url = environment.plantas + "v1/facilities-maintenance/";   
  }

  
  findAllPlantas(): Observable<any> {
    let ruta = `${this.url}getFacilitiesList`;
    return this._http.get(ruta);
  }
  deletePlantasById(cadena : string): Observable<any> {
    return this._http.delete(`${this.url}deleteFacility?${cadena}`);
  }
  savePlantas(form : any): Observable<any> {
    let params = JSON.stringify(form);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.post(`${this.url}insertFacility`, params, { headers: headersResp });
  }
  updatePlantas(form : any): Observable<any> {
    let params = JSON.stringify(form);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.put(`${this.url}updateFacility`, params, { headers: headersResp });
  }

}